<template>
  <v-container fluid class="my-0 py-0">
      <v-tabs fixed-tabs background-color="#fff">
        <v-tab>Cuentas</v-tab>
        <v-tab v-if="auth.isVertebra()">Centros de operación</v-tab>
        <v-tab v-if="auth.isVertebra()">Medidores</v-tab>
        <v-tab v-if="auth.isVertebra()">Cargas</v-tab>

        <v-tab-item>
          <Usuarios />
        </v-tab-item>
        <v-tab-item>
          <Ceco />
        </v-tab-item>
        <v-tab-item>
          <Medidor />
        </v-tab-item>
        <v-tab-item>
          <Carga />
        </v-tab-item>
      </v-tabs>
  </v-container>
</template>
<script>
import Vue from "vue";
import axios from "axios";
import moment from "moment";
import { API } from "../../../globals";

import Usuarios from "./Usuarios.vue";
import Ceco from "./Ceco.vue";
import Carga from "./Carga.vue";
import Modulos from "./Modulos.vue";
import Medidor from "./Medidor.vue";
import VMeters from "./VMeters.vue";
import Herramientas from "./Herramientas.vue";
import Variables from "./Variables.vue";
import Indicadores from "./Indicadores.vue";
import AlertsAdministration from "./AlertasAdministracion.vue";
import { Auth } from "../../../classes/Auth";

const auth = new Auth();

export default Vue.extend({
  name: "Ajustes",
  data: () => ({
    auth: auth,
  }),
  components: {
    AlertsAdministration,
    Usuarios,
    Ceco,
    Medidor,
    Carga,
    Herramientas,
    Variables,
    Indicadores,
    VMeters,
    Modulos,
  },
});
</script>
<style lang="scss" scoped>
</style>